import React from 'react'




const Homesec3 = () => {
  return (
	<div>
		
		 <div className="px-4 md:py-12 py-8 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-2">
		 
     <div class="lg:w-1/2  w-full mb-6 lg:mb-0" bis_skin_checked="1">
     <h1 className="sm:text-3xl text-start text-2xl font-medium title-font mb-8 text-[#060A4C] underline">Why Us</h1>
      </div>

	  <div className="grid gap-8 row-gap-5 lg:grid-cols-3">
        <div className="relative p-px overflow-hidden transition duration-300 transform border rounded shadow-sm hover:scale-105 group hover:shadow-xl">
          <div className="absolute bottom-0 left-0 w-full h-1 duration-300 origin-left transform scale-x-0 bg-[#060A4C] group-hover:scale-x-100" />
          <div className="absolute bottom-0 left-0 w-1 h-full duration-300 origin-bottom transform scale-y-0 bg-[#060A4C] group-hover:scale-y-100" />
          <div className="absolute top-0 left-0 w-full h-1 duration-300 origin-right transform scale-x-0 bg-[#060A4C] group-hover:scale-x-100" />
          <div className="absolute bottom-0 right-0 w-1 h-full duration-300 origin-top transform scale-y-0 bg-[#060A4C] group-hover:scale-y-100" />
          <div className="relative p-5 bg-white rounded-sm">
            <div className="flex justify-start gap-2 mb-2 lg:items-center lg:flex-row">
              <div className="flex items-center justify-center w-10 h-10 mb-4 mr-2 rounded-full bg-gray-50 lg:mb-0">
                <svg
                  className="w-8 h-8 text-[#060A4C]"
                  stroke="currentColor"
                  viewBox="0 0 52 52"
                >
                  <polygon
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                    points="29 13 14 29 25 29 23 39 38 23 27 23"
                  />
                </svg>
              </div>
              <h6 className="font-semibold md:pt-0 pt-2 md:text-[14px] text-[14px] text-[#060A4C] leading-5">COMMITTED TO QUALITY</h6>
            </div>
            <p className="mb-2 text-sm text-gray-900 text-start"style={{ fontFamily: 'Poppins', fontWeight: '400' }}>
			We are committed to provide you a quality and reliable product because various visual & other inspection checks are done for process control and testing is the part of system.
            </p>
        
          </div>
        </div>
        <div className="relative p-px overflow-hidden transition duration-300 transform border rounded shadow-sm hover:scale-105 group hover:shadow-xl">
          <div className="absolute bottom-0 left-0 w-full h-1 duration-300 origin-left transform scale-x-0 bg-[#060A4C] group-hover:scale-x-100" />
          <div className="absolute bottom-0 left-0 w-1 h-full duration-300 origin-bottom transform scale-y-0 bg-[#060A4C] group-hover:scale-y-100" />
          <div className="absolute top-0 left-0 w-full h-1 duration-300 origin-right transform scale-x-0 bg-[#060A4C] group-hover:scale-x-100" />
          <div className="absolute bottom-0 right-0 w-1 h-full duration-300 origin-top transform scale-y-0 bg-[#060A4C] group-hover:scale-y-100" />
          <div className="relative p-5 bg-white rounded-sm">
            <div className="flex justify-start gap-2 mb-2 lg:items-center lg:flex-row">
              <div className="flex items-center justify-center w-10 h-10 mb-4 mr-2 rounded-full bg-gray-50 lg:mb-0">
                <svg
                  className="w-8 h-8 text-[#060A4C]"
                  stroke="currentColor"
                  viewBox="0 0 52 52"
                >
                  <polygon
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                    points="29 13 14 29 25 29 23 39 38 23 27 23"
                  />
                </svg>
              </div>
              <h6 className="font-semibold md:pt-0 pt-2 leading-5 md:text-[14px] text-[14px] text-[#060A4C]">THE RIGHT TEAM FOR YOUR PROJECT</h6>
            </div>
            <p className="mb-2 text-sm text-gray-900 text-start"style={{ fontFamily: 'Poppins', fontWeight: '400' }}>
			We strive to offer the best solution for your business. We are constantly upgrading to new technologies and recommend them to install in customer’s place at no extra cost.
            </p>  
          </div>
        </div>
        <div className="relative p-px overflow-hidden transition duration-300 transform border rounded shadow-sm hover:scale-105 group hover:shadow-xl">
          <div className="absolute bottom-0 left-0 w-full h-1 duration-300 origin-left transform scale-x-0 bg-[#060A4C] group-hover:scale-x-100" />
          <div className="absolute bottom-0 left-0 w-1 h-full duration-300 origin-bottom transform scale-y-0 bg-[#060A4C] group-hover:scale-y-100" />
          <div className="absolute top-0 left-0 w-full h-1 duration-300 origin-right transform scale-x-0 bg-[#060A4C] group-hover:scale-x-100" />
          <div className="absolute bottom-0 right-0 w-1 h-full duration-300 origin-top transform scale-y-0 bg-[#060A4C] group-hover:scale-y-100" />
          <div className="relative p-5 bg-white rounded-sm">
            <div className="flex justify-start gap-2 mb-2 lg:items-center lg:flex-row">
              <div className="flex items-center justify-center w-10 h-10 mb-4 mr-2 rounded-full bg-gray-50 lg:mb-0">
                <svg
                  className="w-8 h-8 text-[#060A4C]"
                  stroke="currentColor"
                  viewBox="0 0 52 52"
                >
                  <polygon
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                    points="29 13 14 29 25 29 23 39 38 23 27 23"
                  />
                </svg>
              </div>
              <h6 className="font-semibold md:text-[14px] text-[14px] leading-5 text-[#060A4C]">STRONG CUSTOMER-FOCUSED APPROACH</h6>
            </div>
            <p className="mb-2 text-sm text-gray-900 text-start"style={{ fontFamily: 'Poppins', fontWeight: '400' }}>
			We follow a strong customer-focused approach. Every team member at “JHANSI ELEVATOR” know the value and importance of our customer – YOU! This is why every step from initiation meetings to dispatch.
            </p>
       
       
          </div>
        </div>
      </div>
    </div>
	</div>
  )
}

export default Homesec3